import { useState, useEffect } from 'react';

import { guessedWindowSize } from '../components/helpers/viewport';

export default function useWindowSize() {
  // Initialize with a device-class guess (from the UA-derived deviceType in
  // the Store) rather than undefined - the guess is deterministic on server
  // and client, so SSR output and the client's first render still match.
  const [windowSize, setWindowSize] = useState(guessedWindowSize);
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener('resize', handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}
